import { useContext, useState, useEffect, useMemo } from "react";
import { UserContext } from "../../Context/Context";

export default function LoadingPage({
  isLoading,
  heightProp,
  widthProp,
  topProp,
  leftProp,
  colorProp = "",
}) {
  const rectsConfig = useMemo(
    () => [
      {
        svgProps: {
          width: 120,
          height: 120,
          viewBox: "0 0 180 180",
          style: {},
        },
        rectProps: { x: 35, y: 35, width: 110, height: 110, strokeWidth: 3 },
        className: "spin", // ahora controlamos la animación por clase
      },
      {
        svgProps: {
          width: 140,
          height: 140,
          viewBox: "0 0 140 140",
          style: { position: "absolute" },
        },
        rectProps: { x: 30, y: 30, width: 80, height: 80, strokeWidth: 2 },
        className: "spin-reverse",
      },
    ],
    [],
  );

  // en lugar de useContext(UserContext)
  const [showLoader, setShowLoader] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let timeoutHide;
    if (isLoading) {
      setShowLoader(true);
      setFadeOut(false);
    } else {
      // Iniciamos la animación de fadeOut y ocultamos después del timeout
      setFadeOut(true);
      timeoutHide = setTimeout(() => setShowLoader(false), 1000); // ajusta 600 al tiempo de tu CSS
    }

    return () => {
      clearTimeout(timeoutHide);
    };
  }, [isLoading]);

  if (!showLoader) return null;

  return (
    <div
      style={{
        position: "relative",
        height: heightProp ? heightProp : "100vh",
      }}>
      <div
        className={fadeOut ? "fadeOutContainer" : "fadeInContainer"}
        role="alert"
        aria-live="assertive"
        aria-label="Loading content"
        style={{
          height: heightProp ? heightProp : "100vh",
          width: widthProp ? widthProp : "unset",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}>
        {rectsConfig.map(({ svgProps, rectProps, className }, i) => (
          <svg key={i} {...svgProps} aria-hidden="true">
            <rect
              className={`${className} rotatingRect`}
              fill="none"
              stroke={colorProp ? colorProp : "#2065d1"}
              {...rectProps}
            />
          </svg>
        ))}
      </div>
    </div>
  );
}
